<template>
  <div>
    <div class="box">
      <div class="inner-box">
        <div class="obj-title">
          发布作业:
        </div>
        <div>
          {{ testPaperName }}
        </div>
      </div>
    </div>
    <div class="box">
      <BInputPullDown
        label-name="选择章节:"
        placeholder="请选择章节"
        v-model="lessonId"
        :Options="lessonList"
      />
    </div>
    <div class="box">
      <div class="inner-box">
        <div class="obj-title">
          发布对象:
        </div>
        <div style="color:green;cursor:pointer;" @click="selectRelease">
          选择发布对象
        </div>
      </div>
    </div>
    <div class="box1" v-if="releaseList.length != 0">
      <div v-for="(item, index) in releaseList" :key="index">
        <div class="name" v-if="item.checked">
          {{ item.name }}
        </div>
        <img
          v-if="item.checked"
          class="delete-img"
          src="@/assets/circle-delete.png"
          v-on:click="deleteClass(index)"
          alt=""
        />
      </div>
    </div>
    <div class="box" style="margin-left: 15px">
      <BInputTimeRange
        v-model="time"
        from-text="生效时段:"
        to-text="至"
        @startTimeChange="startDateChange"
        @endTimeChange="endDateChange"
      />
    </div>
    <div class="box" style="margin-top: -20px; margin-left: 10px">
      <BBtnSwitch  label-text="批阅前重做：" v-model="editSwitchFlag" />
    </div>
    <div class="box">
      <BBtnPrimary
        :clicked="onClickAddCourse"
        btn-txt="发布"
        btn-width="100"
        btn-height="100"
      />
      <BBtnPrimary
            :clicked="doBack"
            btn-txt="返回"
            btn-width="100"
            btn-height="100"
          />
    </div>
  </div>
</template>
<script>
import BInputTimeRange from "../../components2/BInputTimeRange";
import BBtnSwitch from "../../components2/BBtnSwitch";
import BBtnPrimary from "../../components2/BBtnPrimary";
import BInputPullDown from "../../components2/BInputPullDown";
import Hub from "../../events/Hub";
import TestPaperDialog from "../../views2/sample/TestPaperDialog";
import Vue from "vue";
import {
  releaseInIt,
  classInit,
  release,
  releaseDetail,
  updateRelease,
} from "@/api/testPaperRelease";
export default {
  components: {
    BInputTimeRange,
    BBtnSwitch,
    BBtnPrimary,
    BInputPullDown,
  },
  data() {
    return {
      menu: false,
      menu2: false,
      landscape: true,
      Param: {},
      editSwitchFlag: true,
      addParam: {},
      snackbar: false,
      timeout: 3000,
      testPaperName: "",
      updateSuccess: false,
      selectDialog: false,
      courseList: [],
      releaseList: [],
      lessonList: [],
      selectCode: [],
      time: {
        from: "",
        to: "",
      },
      data: {},
      data_courseId: "",
      data_classId: "",
      data_paperId: "",
      data_paperReleaseId: "",
      lessonId: "",
      releaseSelList: [],
      navi: [
        {name: "course-management"},
        {name: "course_homework-release"},
        {name: "course_homework-bank"},
        {name: "course_homework-release-add"},
      ],
      navi2: [
        {name: "class-management"},
        {name: "class-test-homework-release"},
        {name: "course_homework-release-add"},
      ],
    };
  },
  props: ["courseId", "classId", "paperId", "paperReleaseId"],
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
  mounted() {
    if (String(this.$route.path).indexOf("class-management-public") == -1) {
      this.$store.commit('SET_NAVI_DATA', this.navi);
    } else {
      this.$store.commit('SET_NAVI_DATA', this.navi2);
    }
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
    this.data_courseId = this.$props.courseId;
    this.data_classId = this.$props.classId;
    this.data_paperId = this.$props.paperId;
    this.data_paperReleaseId = this.$props.paperReleaseId;
console.log("data_courseId = ",this.data_courseId);
console.log("data_classId = ",this.data_classId);
console.log("data_paperId = ",this.data_paperId);
console.log("this.data_paperReleaseId = ",this.data_paperReleaseId);
    if (this.data_courseId && this.data_paperId) {
      // 初始化
      this.releaseInIt(this.data_paperId);
      this.classInit(this.data_courseId,this.data_classId);
    }
    if (this.data_paperReleaseId) {
      this.releaseDetail(this.data_paperReleaseId);
    }
  },
  methods: {
    // 发布详情
    async releaseDetail(id) {
      var params = {
        id: id,
      };
      const data = await releaseDetail(params);
      this.testPaperName = data.data.data.testPaperName;
      this.data_paperId = data.data.data.paperId;
      this.releaseSelList = data.data.data.releaseSelList;
      await this.releaseInIt(this.data_paperId);
      this.data_courseId = data.data.data.courseId;
      await this.classInit(this.data_courseId,this.data_classId);
      this.lessonId = data.data.data.lessonId;
      this.time.from = data.data.data.validStartTime;
      this.time.to = data.data.data.validEndTime;
      if(data.data.data.overReadEditFlg === "1"){
          this.editSwitchFlag = true
      }else{
          this.editSwitchFlag = false
      }
      for (var rel of this.releaseList) {
        for (var dto of this.releaseSelList) {
          if (dto.classId === rel.id) {
            rel.checked = true;
          }
          for (var rels of rel.children) {
            for (var dta of dto.studentCheckedList) {
              if (dto.classId === rel.id && rels.id === dta) {
                rels.checked = true;
              }
            }
          }
        }
      }
    },
    // 选择发布对象
    selectRelease() {
      if (this.releaseList !== null) {
        this.data.treeData = JSON.parse(JSON.stringify(this.releaseList));
      }
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data, "选择发布对象", TestPaperDialog);
    },

    async releaseInIt(id) {
      var params = {
        id: id,
      };
      const data = await releaseInIt(params);
      this.testPaperName = data.data.testPaperName;
      this.courseList = data.data.courseList;
    },
    async classInit(courseId, classId) {
      if (classId == ""|| classId == undefined) {
        classId = null
      }
      var param = {
        courseId: courseId,
        classId: classId,
      };
      const data = await classInit(param);
      this.releaseList = data.data.releaseList;
      this.lessonList = data.data.lessonNameList;
    },
    onClickAddCourse() {
      if (this.releaseSelList == null || this.releaseSelList.length == 0) {
        Vue.prototype.$valertbar.show("请选择发布对象");
        return false;
      }
      if (
        this.lessonId === "" ||
        this.lessonId === undefined ||
        this.lessonId === null
      ) {
        Vue.prototype.$valertbar.show("请输入课时");
        return false;
      }
      if (
        this.time.from === "" ||
        this.time.from === undefined ||
        this.time.from === null
      ) {
        Vue.prototype.$valertbar.show("请选择生效开始时间");
        return false;
      }
      if (
        this.time.to === "" ||
        this.time.to === undefined ||
        this.time.to === null
      ) {
        Vue.prototype.$valertbar.show("请选择生效结束时间");
        return false;
      }
      if (
        new Date(this.time.from).getTime() < new Date().getTime()
      ) {
        Vue.prototype.$valertbar.show("生效开始时间必须是未来时间");
        return false;
      }
      this.time.to = this.time.to.replace(' ', 'T')
      this.time.from = this.time.from.replace(' ', 'T')
      if (this.time.from > this.time.to) {
        Vue.prototype.$valertbar.show("生效结束时间要大于生效开始时间");
        return false;
      }
      var param = {};
      param.bbxTestPaperId = this.data_paperId;
      param.bbxTrainCourseId = this.data_courseId;
      param.bbxTrainLessonId = this.lessonId;
      param.validEndTime =  this.time.to
      param.validStartTime = this.time.from
      param.releaseList = this.releaseSelList;
      param.passScore = 0;
      if(this.editSwitchFlag){
        param.overReadEditFlg = 1
      }else{
        param.overReadEditFlg = 0
      }

      if (this.data_paperReleaseId) {
        param.id = this.data_paperReleaseId;
        this.updateRelease(param);
      } else {
        this.releaseHomework(param);
      }
    },
    async updateRelease(param) {
      const data = await updateRelease(param);
      if (data.code === 0) {
        this.data_paperReleaseId = "";
        Vue.prototype.$vsnackbar.show("更新成功");
        var obj = {
          flag: 5,
        };
        this.$emit("openFlag", obj);
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    async releaseHomework(param) {
      const data = await release(param);
      if (data.code === 0) {
        this.data_paperReleaseId = "";
        Vue.prototype.$vsnackbar.show("发布成功");
        var obj = {
          flag: 5,
        };
        this.$emit("openFlag", obj);
      } else {
        Vue.prototype.$valertbar.show(data.msg);
      }
    },
    startDateChange(value) {
      this.time.from = value;
    },
    endDateChange(value) {
      this.time.to = value;
    },
    set(value) {
      this.releaseList = value.treeData
      this.releaseSelList = value.array;
    },
    switchChange(value) {
      if (value) {
        this.addParam.overReadEditFlg = 1;
      } else {
        this.addParam.overReadEditFlg = 0;
      }
    },
    deleteClass(index) {
      this.releaseList[index].checked = false;
      for (var child of this.releaseList[index].children) {
        child.checked = false;
      }

      this.releaseSelList = [];
      for (var a = 0; a < this.releaseList.length; a++) {
        if (this.releaseList[a].checked == true) {
          var studentCheckedList = [];
          var checkedObject = {};
          checkedObject.classId = this.releaseList[a].id;
          for (var c = 0; c < this.releaseList[a].children.length; c++) {
            if (this.releaseList[a].children[c].checked == true) {
              studentCheckedList.push(this.releaseList[a].children[c].id);
            }
          }
          checkedObject.studentCheckedList = studentCheckedList;
          this.releaseSelList.push(checkedObject);
        }
      }
    },
    // 返回
    doBack() {
      if (this.data_paperReleaseId) {
        var obj = {
            flag: 5,
          };
        this.$emit("openFlag", obj);
      }else {
        obj = {
            flag: 'homeworkBank',
        };
        this.$emit("openFlag", obj);
      }
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 10px 20px 10px;
}

.obj-title {
  color: #333333;
  text-align: right;
  font-size: 14px;
  margin: 0 10px 0 25px;
}

.inner-box {
  display: flex;
  flex-direction: row;
}

.name {
  margin-left: 15px;
}

.delete-img {
  position: relative;
  width: 15px;
  height: 15px;
  top: -25px;
  left: 60px;
}

.box1 {
  display: flex;
  margin-left: 90px;
  margin-bottom: -20px;
}
</style>
